"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPagingArray = void 0;

var createPagingArray = function createPagingArray(total, pageSize) {
  var length = total ? Math.ceil(total / pageSize) : 1;
  return Array.from({
    length: length
  }, function (v, k) {
    return k + 1;
  });
};

exports.createPagingArray = createPagingArray;